<template>
	<v-btn 
		:href="href"
		:title="title"
		v-bind="$attrs"
	>
		<slot>{{ config.tel }}</slot>
	</v-btn>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
	data:() => ({
		href: null,
		title: null
	}),
	computed: {
		...mapGetters(['config'])
	},
	mounted() {
		this.href=`tel:${this.config.tel}`
		this.title = this.$attrs.title || `ติดต่อ ${this.config.tel} ทางโทรศัพท์`
	}
}

</script>
